import React, { memo } from "react";
import { Item as ItemType, Authorization } from "types";
import { useSelector } from "react-redux";
import type { RootState } from "store";
import { createChange } from "create_change";
import { ItemContent } from "./item_content";

export const Item = memo(
  ({
    item,
    authorization,
    isTemplate,
  }: {
    item: ItemType;
    authorization: Authorization;
    isTemplate: boolean;
  }) => {
    const { isSuggestionMode } = useSelector(
      (state: RootState) => state.suggestion.value,
    );
    const canEditItem = authorization.can_edit_item || isSuggestionMode;
    const checkItem = (item: ItemType) => {
      createChange({
        name: "checkUncheckItem",
        payload: {
          itemId: item.id,
          itemName: item.name,
          checked: !item.checked,
        },
      });
    };

    const checkboxTag = () => {
      if (!isTemplate && authorization.can_edit_item) {
        return (
          <>
            <input
              type="checkbox"
              name="check"
              id={`check-${item.id}`}
              checked={item.checked}
              className="form-check-input me-1 js-item-check"
              data-item-id={item.id}
              onChange={() => {
                checkItem(item);
              }}
            ></input>
          </>
        );
      }
    };

    return (
      <div className="item-group">
        <div className="item-group-checkbox-container">{checkboxTag()}</div>
        <ItemContent
          canEditItem={canEditItem}
          itemId={item.id}
          itemName={item.name}
          itemDescription={item.description}
          itemImages={item.images}
        />
      </div>
    );
  },
);
